/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'

function AuthGuard({ children }: { children?: React.ReactNode }) {
  const location = useLocation()
  const auth = useAuth()

  if (!auth.isInitialized) {
    return null
  }

  if (!auth.isAuthenticated) {
    return (
      <Navigate
        to="/auth/sign-in"
        state={{ from: location.pathname }}
        replace
      />
    )
  }

  return <>{children}</>
}

export default AuthGuard
